import { jsx } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from "react";
import { string, any, number, bool, object } from "prop-types";
import { animationStates, getStyles } from "@ingka/choice-shared";
import { durationSlowWeb } from "@ingka/variables";
function AnimateHeight(props) {
  const {
    children,
    className,
    contentClassName,
    expanded,
    duration = parseInt(durationSlowWeb, 10),
    id,
    style = {},
    ...other
  } = props;
  const contentElement = useRef();
  const animationFrameID = useRef(null);
  const [animationState, setAnimationState] = useState(expanded ? animationStates.STATIC_AUTO : animationStates.STATIC_ZERO);
  useEffect(() => {
    cancelAnimationFrame(animationFrameID.current);
    if (animationState === animationStates.STATIC_AUTO && expanded || animationState === animationStates.STATIC_ZERO && !expanded) {
      return;
    }
    setAnimationState(expanded ? animationStates.PREPARE_ANIMATE_FROM_ZERO : animationStates.PREPARE_ANIMATE_FROM_AUTO);
  }, [expanded]);
  useEffect(() => {
    if (animationState === animationStates.PREPARE_ANIMATE_FROM_ZERO) {
      setAnimationState(animationStates.ANIMATING_TO_AUTO);
    } else if (animationState === animationStates.PREPARE_ANIMATE_FROM_AUTO) {
      setAnimationState(animationStates.ANIMATING_TO_ZERO);
    }
  }, [animationState]);
  useEffect(() => {
    return () => {
      cancelAnimationFrame(animationFrameID.current);
    };
  }, []);
  const isCollapsed = animationState === animationStates.STATIC_ZERO;
  return /* @__PURE__ */ jsx(
    "div",
    {
      "aria-labelledby": other["aria-labelledby"],
      "aria-hidden": isCollapsed,
      className,
      id,
      style: getStyles[animationState](duration, contentElement.current ? contentElement.current.offsetHeight : null),
      onTransitionEnd: () => setAnimationState(expanded ? animationStates.STATIC_AUTO : animationStates.STATIC_ZERO),
      children: /* @__PURE__ */ jsx(
        "div",
        {
          className: contentClassName,
          style: {
            display: isCollapsed ? "none" : null
          },
          ref: contentElement,
          children
        }
      )
    }
  );
}
AnimateHeight.propTypes = {
  "aria-labelledby": string,
  children: any.isRequired,
  className: string,
  contentClassName: string,
  duration: number,
  expanded: bool,
  id: string,
  style: object
};
var AnimateHeight_default = AnimateHeight;
export {
  AnimateHeight_default as default
};
